import { combineReducers } from "redux";

import backdrop from './backdrop';
import language from './language';
import urlMap from './urlMap';
import cookieLaw from './cookielaw';
import search from './search';
import breakingNews from './breakingnews';

export default combineReducers({ backdrop, language, urlMap, cookieLaw, search, breakingNews });
